import { scheduleToast } from '@app/components/Toast';
import type { BgProcessFinishedPayload } from '@app/sockets/socketTypes';

import { defaultFinishedAction, defaultUpdateAction, type Handler } from './common';

type BgCopyKeysPayload = BgProcessFinishedPayload & {
    params: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        key_count: number;
    };
    info: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        keys_copied: number;
    };
};

const handler: Handler = {
    onProgress(payload, toastId, initial) {
        const keyCount = payload.bulk?.keyCount ?? 0;
        if (!keyCount) {
            return;
        }

        defaultUpdateAction(toastId, 'Copying Keys...', payload.progress, keyCount, initial);
    },
    onFinished(payload: BgCopyKeysPayload, isOnProjectPage) {
        const totalKeys = payload.params.key_count;
        const copiedKeys = payload.info.keys_copied;
        const skippedKeys = totalKeys - copiedKeys;

        const additionalMessage = skippedKeys ? `${skippedKeys} skipped keys have duplicates in target project. ` : '';

        defaultFinishedAction(
            isOnProjectPage,
            `${copiedKeys}/${totalKeys} keys copied`,
            payload.params.project_id,
            payload.params.branch_name,
            additionalMessage,
        );
    },
    onEarlyFinish(payload: BgCopyKeysPayload) {
        const totalKeys = payload.params.key_count;
        const copiedKeys = payload.info.keys_copied;
        const skippedKeys = totalKeys - copiedKeys;

        const description = skippedKeys
            ? `${skippedKeys} skipped keys have duplicates in target project. See details in project activity`
            : 'See details in project activity';

        scheduleToast({
            type: 'success',
            title: `${copiedKeys}/${totalKeys} keys copied`,
            description,
        });
    },
};

export default handler;
